module.exports = __webpack_public_path__ + "static/media/ipitch.445be1de.png";